module.exports = __webpack_public_path__ + "static/media/lock-gold.be2f5521.svg";